<template>
  <!-- 产品档次配置弹框 -->
  <Modal
    v-model="visible"
    :title="productInfo.productName + `(${productInfo.productCode})`"
    width="1200"
    class="my-modal add-product-modal top p-b"
    :footer-hide="true"
  >
    <!-- 工具栏 -->
    <div class="tools-box">
      <div class="left-box">
        <Checkbox v-model="isAll" @on-change="selectAll" v-if="detail.mode == 2 && detail.status != '-1'">全部档次</Checkbox>
      </div>
      <div class="right-box" v-if="!tableData.length">
        <Button type="primary" @click="goPage()">新增费用档次</Button>
      </div>
    </div>
    <!-- 表格 -->
    <div class="table-box">
      <loading :isShow="listLoading" />
      <Table :columns="columns" :data="tableData" @on-selection-change="selectRow">
        <template slot-scope="{ row, index }" slot="action">
          <div class="detail" v-if="detail.status != '-1'">
            <div @click="tableData[index].isEdit = true" v-if="!tableData[index].isEdit">编辑</div>
            <div @click="(row.rewardRate = row.oldRate), (tableData[index].isEdit = false)" v-if="tableData[index].isEdit">取消</div>
            <div @click="tableData[index].isEdit = false" v-if="tableData[index].isEdit">确认</div>
          </div>
        </template>
        <template slot-scope="{ column, index }" slot="input">
          <!-- <Input
            :maxlength='3'
            v-model="tableData[index][column.key]"
            placeholder="请输入"
            v-if="tableData[index].isEdit && detail.status != '1' && detail.status != '-1'"
            @on-change="inputChange(index, column, $event)"
          /> -->
          <InputNumber
            v-if="tableData[index].isEdit && detail.status != '-1'"
            :max="999.99"
            :min="0"
            v-model="tableData[index][column.key]"
          ></InputNumber>
          <span v-else>{{ tableData[index][column.key] || '-' }}</span>
        </template>
      </Table>
    </div>

    <div class="height" v-if="!(detail.status == '-1') && compontntType != 'configModal'"></div>
    <div class="ivu-modal-footer" v-if="!(detail.status == '-1') && compontntType != 'configModal'">
      <Button @click="visible = false">取消</Button>
      <Button type="primary" @click="ok" :loading="loading">确定</Button>
    </div>
  </Modal>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
export default {
  components: {},
  mixins: [pageTool, common],
  props: ['companyList', 'compontntType'],
  data() {
    return {
      detail: {},
      productInfo: {},
      isAll: false,
      selectArr: [], //表格选择的数据
      visible: false,
      columns: [],
      loading: false
    };
  },

  methods: {
    open(item, dataInfo, id) {
      this.columns = [];
      this.detail = dataInfo;
      this.detail.id = this.detail.id ? this.detail.id : id;
      this.productInfo = item;
      this.isAll = false;
      this.tableData = [];
      this.selectArr = [];
      this.setColumns();
      this.initListAjax('/buz/merchantActivity/queryProductGrade');
      if (dataInfo.mode == 1) {
        this.columns.push({
          title: '活动奖励（%）',
          align: 'center',
          key: 'rewardRate',
          slot: 'input'
        });
      } else {
        this.columns.unshift({
          type: 'selection',
          width: 60,
          align: 'center'
        });
      }
      if (this.compontntType != 'configModal') {
        this.columns.push({
          title: '操作',
          align: 'center',
          slot: 'action'
        });
      }
      this.visible = true;
      // 团财不显示
      if (this.detail.productType == 2) {
        this.columns = this.columns.filter(item => item.title != '保障期' && item.title != '交费期' && item.title != '险种名称');
      }
    },
    ok() {
      if (this.detail.mode == 1) {
        this.productInfo.programJoins = this.tableData;
        let arr = this.tableData.filter(item => !item.rewardRate);
        if (arr.length === this.tableData.length) {
          this.$notice.error('至少需要填写一个信息');
        } else {
          this.$notice.success('配置成功');
          this.visible = false;
        }
      } else {
        this.productInfo.programJoins = this.isAll ? this.tableData : this.tableData.filter(v => this.selectArr.includes(v.programId));
        if (!this.productInfo.programJoins.length) {
          this.$notice.error('至少需要勾选一个信息');
        } else {
          this.$notice.success('配置成功');
          this.visible = false;
        }
      }
    },
    // 获取列表参数
    setListParams(params) {
      params.productCode = this.productInfo.productCode;
      params.productId = this.productInfo.productId;
      params.pageSize = 999;
      if (this.detail.id || this.detail.activityId) {
        params.activityId = this.detail.id || this.detail.activityId;
      }
    },
    listCallback(res) {
      res.data.forEach(item => {
        item.rewardRate = item.rewardRate? Number(item.rewardRate): null;
        item.isEdit = false;
        // 处理无门槛临时添加的回显
        if (this.productInfo?.programJoins?.length && this.detail.mode == 1) {
          this.productInfo.programJoins.map(v => {
            if (item.programId == v.programId) {
              item.rewardRate = v.rewardRate;
            }
          });
        }
        // 处理梯度临时添加的回显
        if (this.productInfo?.programJoins?.length && this.detail.mode == 2) {
          this.selectArr = this.productInfo?.programJoins?.map(v => v.programId) || [];
        }
        //处理梯度已添加的回显
        if (item.isAdd == 1 && !this.selectArr.includes(item.programId)) {
          this.selectArr.push(item.programId);
        }
        item.oldRate = item.rewardRate || '';
        this.selectArr.forEach(item2 => {
          if (item.programId == item2) {
            item._checked = true;
          }
        });
        if (this.isAll) {
          item._checked = true;
          item._disabled = true;
        }
        if (this.detail.status == '-1' || this.compontntType == 'configModal') {
          item._disabled = true;
        }
      });
    },
    // 全部选择
    selectAll(status) {
      const tableData = JSON.parse(JSON.stringify(this.tableData));
      tableData.forEach(item => {
        item._disabled = status;
        item._checked = status;
      });
      this.tableData = tableData;
      this.selectArr = [];
    },
    // 选中某个
    selectRow(curSelectArr) {
      const codes = curSelectArr.map(item => item.programId); //当前页勾选的
      const selectCodes = this.selectArr.map(item => item); //已经添加的数据
      this.tableData.forEach(item => {
        if (codes.includes(item.programId) && !selectCodes.includes(item.programId)) {
          //未添加已勾选的数据时添加数据
          this.selectArr.push(item.programId);
          selectCodes.push(item.programId);
        } else if (!codes.includes(item.programId) && selectCodes.includes(item.programId)) {
          //添加了未勾选的数据时删除
          this.selectArr.splice(selectCodes.indexOf(item.programId), 1);
          selectCodes.splice(selectCodes.indexOf(item.programId), 1);
        }
      });
    },
    inputChange(index, column, e) {
      this.$nextTick(() => {
        this.tableData[index][column.key] = e.target.value >= 0 ? e.target.value : 0;
      });
    },
    goPage() {
      if (this.productInfo.sourceType == 2) {
        this.openPageTabTags('/productResource/productManager/productEdit', {
          id: this.productInfo.productId,
          code: this.productInfo.productCode,
          tab: '2',
          timeStr: new Date().getTime()
        });
      } else {
        this.openPageTabTags('/productResource/productManager/productDetail', {
          id: this.productInfo.productId,
          code: this.productInfo.productCode,
          tab: '2',
          timeStr: new Date().getTime(),
          sourceType: this.productInfo.sourceType
        });
      }
    },
    setColumns() {
      this.columns = [
        {
          title: '序号',
          type: 'index',
          width: 80,
          align: 'center'
        },
        {
          title: '险种名称',
          key: 'gradeName',
          align: 'center',
          render(h, params) {
            if (params.row.isMain == 1) {
              return <span>{params.row.gradeName}</span>;
            } else {
              return (
                <div>
                  <Tag color="blue">附</Tag>
                  <span>{params.row.gradeName}</span>
                </div>
              );
            }
          }
        },
        {
          title: '方案名称',
          key: 'programName',
          align: 'center'
        },
        {
          title: '保障期',
          key: 'guaranteeContent',
          align: 'center'
        },
        {
          title: '交费期',
          key: 'payTerm',
          align: 'center'
        }
      ];
    }
  }
};
</script>
<style lang="scss" scoped>
.add-product-modal {
  padding-top: 20px;
  .btn3 {
    padding-right: 100px;
  }
  .search-wrap {
    margin: 10px 0;
    .ivu-btn {
      position: absolute;
      right: 30px;
    }
    .ivu-select-selection {
      border-radius: 2px;
      height: 30px;
    }
  }
  .ivu-tabs-nav-container {
    font-size: 16px;

    .ivu-tabs-tab {
      padding: 10px 24px;
    }
  }
  /deep/.ivu-modal-body {
    padding-top: 20px;
  }
}
.height {
  height: 60px;
}
/deep/ .ivu-modal-footer {
  margin-top: 50px;
}
</style>
